// This function limits the rate at which a given function can be executed.
// It ensures that the function is called at most once within the specified time limit.
// Useful for optimizing performance in scenarios like event handling (e.g., scroll or resize events).
export function throttle<T extends (...args: any[]) => void>(func: T, limit: number): T {
    let inThrottle = false;
    return function (this: unknown, ...args: Parameters<T>) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    } as T;
  }
